import { Component } from '@angular/core';

@Component({
  selector: 'app-print-asset-link',
  templateUrl: './print-asset-link.component.html',
  styleUrls: ['./print-asset-link.component.scss']
})
export class PrintAssetLinkComponent {

}
